export const DotDotDot = () => {
  return (
    <div>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75004 8.66675C9.11823 8.66675 9.41671 8.36827 9.41671 8.00008C9.41671 7.63189 9.11823 7.33341 8.75004 7.33341C8.38185 7.33341 8.08337 7.63189 8.08337 8.00008C8.08337 8.36827 8.38185 8.66675 8.75004 8.66675Z"
          stroke="#98A2B3"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.75004 4.00008C9.11823 4.00008 9.41671 3.7016 9.41671 3.33341C9.41671 2.96522 9.11823 2.66675 8.75004 2.66675C8.38185 2.66675 8.08337 2.96522 8.08337 3.33341C8.08337 3.7016 8.38185 4.00008 8.75004 4.00008Z"
          stroke="#98A2B3"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.75004 13.3334C9.11823 13.3334 9.41671 13.0349 9.41671 12.6667C9.41671 12.2986 9.11823 12.0001 8.75004 12.0001C8.38185 12.0001 8.08337 12.2986 8.08337 12.6667C8.08337 13.0349 8.38185 13.3334 8.75004 13.3334Z"
          stroke="#98A2B3"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.61342 8.47537C1.52262 8.33161 1.47723 8.25973 1.45182 8.14886C1.43273 8.06559 1.43273 7.93425 1.45182 7.85097C1.47723 7.74011 1.52262 7.66823 1.61341 7.52447C2.36369 6.33648 4.59693 3.33325 8.00027 3.33325C11.4036 3.33325 13.6369 6.33648 14.3871 7.52447C14.4779 7.66823 14.5233 7.74011 14.5487 7.85097C14.5678 7.93425 14.5678 8.06559 14.5487 8.14886C14.5233 8.25973 14.4779 8.33161 14.3871 8.47537C13.6369 9.66336 11.4036 12.6666 8.00027 12.6666C4.59693 12.6666 2.36369 9.66336 1.61342 8.47537Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00027 9.99992C9.10484 9.99992 10.0003 9.10449 10.0003 7.99992C10.0003 6.89535 9.10484 5.99992 8.00027 5.99992C6.8957 5.99992 6.00027 6.89535 6.00027 7.99992C6.00027 9.10449 6.8957 9.99992 8.00027 9.99992Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
